export default __webpack_public_path__ + "static/media/polygon-edit.735ecf92.svg";